export const ActiveVariantsMapSym = Symbol('ActiveVariantsMap')
